module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(!_vm.range && _vm.showInput) ? _c('Input-number', {
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "value": _vm.currentValue,
      "disabled": _vm.disabled
    },
    on: {
      "on-change": _vm.handleInputChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "slider",
    class: [_vm.prefixCls + '-wrap'],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.sliderClick($event)
      }
    }
  }, [(_vm.showStops) ? _vm._l((_vm.stops), function(item) {
    return _c('div', {
      class: [_vm.prefixCls + '-stop'],
      style: ({
        'left': item + '%'
      }),
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.sliderClick($event)
        }
      }
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-bar'],
    style: (_vm.barStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.sliderClick($event)
      }
    }
  }), _vm._v(" "), (_vm.range) ? [_c('div', {
    class: [_vm.prefixCls + '-button-wrap'],
    style: ({
      left: _vm.firstPosition + '%'
    }),
    on: {
      "mousedown": _vm.onFirstButtonDown
    }
  }, [_c('Tooltip', {
    ref: "tooltip",
    attrs: {
      "controlled": _vm.firstDragging,
      "placement": "top",
      "content": _vm.tipFormat(_vm.currentValue[0]),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always'
    }
  }, [_c('div', {
    class: _vm.button1Classes
  })])], 1), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-button-wrap'],
    style: ({
      left: _vm.secondPosition + '%'
    }),
    on: {
      "mousedown": _vm.onSecondButtonDown
    }
  }, [_c('Tooltip', {
    ref: "tooltip2",
    attrs: {
      "controlled": _vm.secondDragging,
      "placement": "top",
      "content": _vm.tipFormat(_vm.currentValue[1]),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always'
    }
  }, [_c('div', {
    class: _vm.button2Classes
  })])], 1)] : [_c('div', {
    class: [_vm.prefixCls + '-button-wrap'],
    style: ({
      left: _vm.singlePosition + '%'
    }),
    on: {
      "mousedown": _vm.onSingleButtonDown
    }
  }, [_c('Tooltip', {
    ref: "tooltip",
    attrs: {
      "controlled": _vm.dragging,
      "placement": "top",
      "content": _vm.tipFormat(_vm.currentValue),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always'
    }
  }, [_c('div', {
    class: _vm.buttonClasses
  })])], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c12d5a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/slider/slider.vue
// module id = 667
// module chunks = 1